/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Entitlements_AnswerInputs */

const en_landing_faq_entitlements_answer = /** @type {(inputs: Landing_Faq_Entitlements_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access mirrors the entitlement model you already run, so a client can only ever reach the research they are permissioned for, and every query is logged for compliance review.`)
};

/**
* | output |
* | --- |
* | "Access mirrors the entitlement model you already run, so a client can only ever reach the research they are permissioned for, and every query is logged for c..." |
*
* @param {Landing_Faq_Entitlements_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_entitlements_answer = /** @type {((inputs?: Landing_Faq_Entitlements_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Entitlements_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_entitlements_answer(inputs)
});